import { Helmet } from "react-helmet-async"
import { observer } from "mobx-react-lite"
import { Button, Group, Title, Flex } from "@mantine/core"
import { Link } from "react-router-dom"
import { PATHS } from "../../shared/lib/paths"
import { ScheduleTable, ScheduleTableRow } from "widgets/schedule"
import { ScheduleSearch, ScheduleTypeToggler } from "../../features/schedule"

// ----------------------------------------------------------------------

export const ScheduleTablePage = observer(function ScheduleTablePage() {
  return (
    <>
      <Helmet>
        <title>Расписание - админка</title>
      </Helmet>

      <Flex direction="column" w="100%">
        <Group position="apart" spacing="xl" mb="xl" pb="md">
          <Title order={1} size={24}>
            Расписание
          </Title>
          <Button component={Link} to={PATHS.DASHBOARD.SCHEDULE.CREATE}>Запланировать событие</Button>
        </Group>

        <Group position="apart" mb="sm" spacing="xl">
          <ScheduleSearch size="md" sx={{ flex: "auto" }}/>
          <ScheduleTypeToggler/>
        </Group>

        <ScheduleTable rowComponent={ScheduleTableRow}/>

      </Flex>
    </>
  )
})
